<template>
  <div class="red-packet1-dialog">
    <div class="red-packet1-content">
      <div class="z-index2">
        <main>
          <div class="middle-cornerWord" v-if="riverData.cornerWord">{{riverData.cornerWord}}</div>
          <div class="middle">
            <img :src="riverData.icon" class="middle-img">
            <span class="middle-productName">{{riverData.productName}}</span>
          </div>
          <div class="content">
            <p>最高可借（元）</p>
            <div class="e-du-gao-da"><span class="red">{{riverData.configLimit|amount}}</span> </div>
            <p>年化利率 {{riverData.minPrice}}%-{{riverData.maxPrice}}%</p>
          </div>
        </main>
        <div class="tong-guo-lv">通过率限时翻倍</div>
        <nd-button class="btn mt11" @click="goRiver"
                   v-stat="{
                     id: 10279,
                     args: {
                       target: riverData.configId
                     },
                   }"
        >立即领取<span v-if="time">（{{time}}S）</span>
        </nd-button>
        <div class="xie-yi">申请并同意<a @click="jumpProtocol">《用户授权协议》</a></div>
      </div>
    </div>
  </div>
</template>
<script>
import { setKey } from '@/assets/utils'
import { mapActions } from 'vuex'
import { removeKey } from '../../../../assets/utils'
export default {
  data () {
    return {
      visible: true,
      time: 3, // 倒计时
      timer: null
    }
  },
  props: {
    riverData: {
      type: Object,
      default: () => ({})
    }
  },
  filters: {
    isEmpty (value) {
      return value ? `${value}天` : ''
    }
  },
  computed: { 
    screen () {
      return this.riverData.popupTag === 'DIVERSION_V2' ? 'river_diversion2' : 'river_diversion'
    }
  },
  watch: {

  },
  mounted () {
    this.$sensors.track('Diversion_Exposure', { product_type: 'diversion', element_positon: this.riverData.popupTag === 'DIVERSION_V2' ? 'product_pop2' : 'product_pop1', product_code: this.riverData.configId })
  },
  destroyed () {
    clearInterval(this.timer)
  },
  methods: {
    ...mapActions(['dataPoint']),
    ...mapActions('user', ['getBorrowPopJumpX']),
    // 跳转到协议
    jumpProtocol () {
      removeKey('river_configId')
      this.$router.push('/river/diversion/protocol')
    },
    close () {
      this.visible = false
      this.$report({
        id: 10278,
        args: {
          visible: 0,
          target: this.riverData.configId
        }
      })
      this.$emit('close')
    },
    goRiver () {
      // this.$emit('close')
      let sourceData = window.location.href
      const { configId, productName, logo, configLimit, needExLogin, autoJump, diversionMode } = this.riverData || {}
      this.$sensors.track('Diversion_Click', { product_type: 'diversion', element_positon: this.riverData.popupTag === 'DIVERSION_V2' ? 'product_pop2' : 'product_pop1', product_code: configId })
      this.$report({
        id: 10269,
        args: {
          screen: this.screen, status: 'draw', target: configId
        }
      })
      this.dataPoint(
        {
          id: 10269, screen: this.screen, status: 'draw', target: configId
        }
      )// 同步埋点
      // 后端埋点
      this.getBorrowPopJumpX({
        configId: this.riverData.configId
      })
      this.$router.push({ path: '/river/middle', query: { configId, productName, logo, configLimit, needExLogin, autoJump, diversionMode, ...sourceData } })
    },
    show () {
      const { configId, homePagePopupStatus } = this.riverData || {}
      this.timer = setInterval(() => {
        if (this.time < 1) {
          clearInterval(this.timer)
          if (homePagePopupStatus === 0) {
            this.goRiver()
          } else if (homePagePopupStatus === 1) {
            this.close()
          }
        } else {
          this.time--
        }
      }, 1000)
      this.$report({
        id: 10121,
        args: { visible: 1, screen: this.screen, step: 'home', target: configId }
      }) // ${this.riverData.configId}
      setKey(`river_configId`, Date.now())
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.red-packet1-dialog {
  
    .red-packet1-content {
        width: 620px;
        border-radius: 30px;
        position: relative;
        background-size: 100%;
        .red-packet1-img{
            width: 620px;
            height: 150px;
            border-radius: 30px;
            position: absolute;
            background-size: 100%;
            z-index: 3;
        }
    }
    a{
        color:#8EB2D8;
    }
    .btn{
        width: 440px;
        text-align: center;
        height: 80px;
        background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
        border-radius: 40px;
        text-align: center;
        line-height: 80px;
        font-size: 36px;
        font-weight: 600;
        color: #FFFFFF;
        margin:auto;
    }
    .mt11{
        margin-top:11px;
    }
    .z-index2{
      padding-bottom: 40px;
        position: relative;
        z-index:2;
        height: 100%;
        background:white;
        border-radius: 31px;
        padding-top: 60px;
    }
    main{
        font-family: PingFangSC-Medium, PingFang SC;
        background: url(./img_kapian.png) no-repeat;
        background-size: 100% 100%;
        width:620px;
        height:459px;
        position: relative;
        .middle{
            display:flex;
            align-items:center;
            position: absolute;
            top:120px;
            left:60px;
            &-img{
                width: 48px;
                height: 48px;
                border-radius:20px;
            }
            &-productName{
                height: 40px;
                font-size: 28px;
                font-weight: 500;
                color: #333333;
                line-height: 40px;
                margin-left:25px;
            }
            &-cornerWord{
              position: absolute;
              width: 153px;
              height: 50px;
              font-size: 36px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #FFFFFF;
              line-height: 50px;
              right: 60px;
              top:106px
            }
           
        }
        .content{
              position: absolute;
              left: 60px; 
              top:190px;
              p {
                font-size: 22px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #76604E;
              }
              .e-du-gao-da {
                font-size: 80px;
font-family: DIN-Medium, DIN;
font-weight: 500;
color: #644421;
              }
            }
        .red{
            color:#644421;
        }
       
        .nian-hua-li-lv{
            height: 33px;
            font-size: 24px;
            font-weight: 400;
            color: #666666;
            line-height: 33px;
        }
    }
    .tong-guo-lv{
        display: inline-block;
        line-height:48px;
        background: linear-gradient(270deg, #FEF6E4 0%, #FCD5AC 100%);
        border-radius: 100px 100px 100px 0px;
        font-size: 22px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #763E12;
        padding:9px 28px;
        margin:30px 0 0 320px;
    }
    .xie-yi{
        margin-top:28px;
        font-size: 24px;
        font-weight: 400;
        color: #666666;
        text-align: center;
    }
}
</style>
